import * as React from 'react'
import {FC, memo} from 'react'
import Distance from '../distance'
import TransportInfo from '../transport-info'
import HandlingInfo from '../handling-info'
import {FormInstance} from 'antd/lib/form'
import {ProgramInfo} from '../../types/models/program-info'

interface TransportParamsPropsInterface {
    form: FormInstance
    onValueChange: (fieldName: string | string[]) => void
    programInfo: ProgramInfo
}

const TransportParams: FC<TransportParamsPropsInterface> = memo(
    ({form, onValueChange, programInfo}) => {
        return (
            <div className='e-smart-padding-left'>
                <Distance onValueChange={onValueChange} programInfo={programInfo} form={form} />
                <TransportInfo
                    onValueChange={onValueChange}
                    programInfo={programInfo}
                    form={form}
                />
                <HandlingInfo onValueChange={onValueChange} programInfo={programInfo} />
            </div>
        )
    }
)

export default TransportParams
